import SkapaSlider, {
  SliderInputControls,
  type SliderInputControlsProps,
  type SliderProps,
} from "@ingka/slider";

export const Slider = (props: SliderProps) => {
  return <SkapaSlider prefix="saleslead__" {...props} />;
};

export const SliderInputControl = (props: SliderInputControlsProps) => {
  return <SliderInputControls {...props} />;
  // TODO: prefix="saleslead__" is missing in the above line since it is not allowed in typing. Seems strange?
};
